import React from 'react';
import { AiOutlineDelete, AiOutlinePlus } from "react-icons/ai";
import { FiBriefcase, FiCalendar, FiInfo } from "react-icons/fi";

const ExperienceForm = ({ formData, setFormData }) => {
  const handleExperienceChange = (index, field, value) => {
    const newExperience = [...formData.experiences];
    newExperience[index][field] = value;
    setFormData({ ...formData, experiences: newExperience });
  };

  const handleWorkSummaryChange = (experienceIndex, summaryIndex, value) => {
    const newExperience = [...formData.experiences];
    newExperience[experienceIndex].workSummary[summaryIndex] = value;
    setFormData({ ...formData, experiences: newExperience });
  };

  const addWorkSummaryItem = (experienceIndex) => {
    const newExperience = [...formData.experiences];
    newExperience[experienceIndex].workSummary.push('');
    setFormData({ ...formData, experiences: newExperience });
  };

  const removeWorkSummaryItem = (experienceIndex, summaryIndex) => {
    const newExperience = [...formData.experiences];
    newExperience[experienceIndex].workSummary = newExperience[experienceIndex].workSummary.filter((_, idx) => idx !== summaryIndex);
    setFormData({ ...formData, experiences: newExperience });
  };

  const addExperience = () => {
    setFormData(prevState => ({
      ...prevState,
      experiences: [...prevState.experiences, { designation: '', company: '', workSummary: [''], startDate: '', endDate: '' }]
    }));
  };

  const removeExperience = (index) => {
    const newExperience = formData.experiences.filter((_, i) => i !== index);
    setFormData({ ...formData, experiences: newExperience });
  };

  return (
    <div className="form-section">
      <div className="helper-text" style={{ marginBottom: 'var(--space-lg)' }}>
        <FiInfo className="helper-icon" />
        Include quantifiable achievements and specific responsibilities for each role
      </div>

      {formData.experiences.map((experience, index) => (
        <div key={index} className="item-container" data-index={index + 1}>
          <div className="form-group">
            <label className="input-label">
              <FiBriefcase style={{ display: 'inline', marginRight: '0.5rem' }} />
              Job Title / Designation
            </label>
            <input
              className='text-input'
              type="text"
              placeholder="e.g., Senior Software Engineer"
              value={experience.designation}
              onChange={(e) => handleExperienceChange(index, 'designation', e.target.value)}
            />
          </div>

          <div className="form-group">
            <label className="input-label">Company Name</label>
            <input
              className='text-input'
              type="text"
              placeholder="e.g., Google Inc."
              value={experience.company}
              onChange={(e) => handleExperienceChange(index, 'company', e.target.value)}
            />
          </div>

          <div className="date-input-grid">
            <div className="form-group">
              <label className="input-label">
                <FiCalendar style={{ display: 'inline', marginRight: '0.5rem' }} />
                Start Date
              </label>
              <input
                className='text-input'
                type="text"
                placeholder="e.g., Jan 2020"
                value={experience.startDate}
                onChange={(e) => handleExperienceChange(index, 'startDate', e.target.value)}
              />
            </div>

            <div className="form-group">
              <label className="input-label">End Date</label>
              <input
                className='text-input'
                type="text"
                placeholder="e.g., Present"
                value={experience.endDate}
                onChange={(e) => handleExperienceChange(index, 'endDate', e.target.value)}
              />
            </div>
          </div>

          <div className="section-divider"></div>

          <div className="summary-section">
            <label className="input-label" style={{ marginBottom: 'var(--space-md)' }}>
              Key Achievements & Responsibilities
            </label>
            
            <div className="helper-text" style={{ marginBottom: 'var(--space-md)' }}>
              <FiInfo className="helper-icon" />
              Use numbers and metrics (e.g., "Increased revenue by 40%" or "Managed team of 5 developers")
            </div>
            
            <div className="summary-list">
              {experience.workSummary.map((summary, summaryIndex) => (
                <div key={summaryIndex} className="summary-item">
                  <div className="summary-bullet"></div>
                  <input
                    className='text-input'
                    type="text"
                    placeholder="e.g., Developed and deployed microservices architecture, reducing latency by 45%"
                    value={summary}
                    onChange={(e) => handleWorkSummaryChange(index, summaryIndex, e.target.value)}
                  />
                  {experience.workSummary.length > 1 && (
                    <button 
                      className='remove-button' 
                      type="button" 
                      onClick={() => removeWorkSummaryItem(index, summaryIndex)}
                      title="Remove point"
                    >
                      <AiOutlineDelete />
                    </button>
                  )}
                </div>
              ))}
            </div>
            
            <div className="button-group">
              <button 
                className='add-button' 
                type="button" 
                onClick={() => addWorkSummaryItem(index)}
              >
                <AiOutlinePlus />
                Add Achievement
              </button>
            </div>
          </div>

          <div className="section-divider"></div>

          <button 
            className='remove-button' 
            type="button" 
            onClick={() => removeExperience(index)}
          >
            <AiOutlineDelete />
            Remove Experience
          </button>
        </div>
      ))}

      <button 
        className='add-button-large' 
        type="button" 
        onClick={addExperience}
      >
        <AiOutlinePlus />
        Add New Experience
      </button>
    </div>
  );
};

export default ExperienceForm;